import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BFormInputDate from './components/BFormInputDate'
import BFormInputDateBetween from './components/BFormInputDateBetween'
import BFormInputTime from './components/BFormInputTime'
import BFormInputPassword from './components/BFormInputPassword'
import BCardCollapse from './components/BCardCollapse'
import BDropdownSidebar from './components/BDropdownSidebar'
import BAlertInfoBox from './components/BAlertInfoBox'
Vue.use(
    BootstrapVue, {
        formTextControls:{
            autocomplete: 'off'
        },
        BTooltip: {
            boundary: 'window',
            noninteractive: true
        }
    }
)
Vue.component('BFormInputPassword', BFormInputPassword)
Vue.component('BFormInputDate', BFormInputDate)
Vue.component('BFormInputDateBetween', BFormInputDateBetween)
Vue.component('BFormInputTime', BFormInputTime)
Vue.component('BCardCollapse', BCardCollapse)
Vue.component('BDropdownSidebar', BDropdownSidebar)
Vue.component('BAlertInfoBox', BAlertInfoBox)